import Route from '@ember/routing/route';
import { service } from '@ember/service';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';
import type SessionContextService from 'tio-employee/services/session-context';
import type { IntlService } from 'ember-intl';
import type { NotificationsService } from 'tio-reimagined/components/notifications';
import type TASProgramTemplateModel from 'tio-common/models/tas-program-template';
import type TASProgramInstanceModel from 'tio-common/models/tas-program-instance';
import { filterEligibleTemplates } from 'tio-common/utils/tuition-assistance/filter-eligibile-templates';
import type EmployeeModel from 'tio-common/models/employee';

export default class AuthenticatedTuitionAssistanceDependentProgramsRoute extends Route {
  @service declare store: StoreService;
  @service declare sessionContext: SessionContextService;
  @service declare notifications: NotificationsService;
  @service declare intl: IntlService;

  async model() {
    const currentEmployee = this.sessionContext.currentEmployee;

    const promises = [
      this.store.query<TASProgramTemplateModel>('tas-program-template', {
        filter: {
          state: 'TAS.ProgramTemplateState.LAUNCHED',
          byEligibility: currentEmployee.id,
          company: currentEmployee.company.id,
        },
        include: 'company.company-setting',
        reload: true,
        page: {
          limit: 100,
        },
      }),
      this.store.query('tas-program-instance', {
        filter: { employee: currentEmployee.id, active: true },
        include: 'tas-program-template,tas-applications',
        page: {
          limit: 100,
        },
      }),
      this.store.query('tas-program-instance', {
        filter: { employee: currentEmployee.id, past: true },
        include: 'tas-program-template',
      }),
      // @ts-expect-error: type model
      this.store.findRecord<EmployeeModel>('employee', currentEmployee.id, {
        include: 'dependents',
      }),
    ];

    const [templates, activeInstances, pastInstances, employee] = await Promise.all(promises);
    // @ts-expect-error not sure
    const tasParticipantId = employee.tasParticipant.id;

    const [dynamicEligibility, programEligibility] = await Promise.all([
      // @ts-expect-error - Ember Data adapter method not typed on MinimumAdapterInterface
      this.store.adapterFor('tas-participant').dynamicEligibility(tasParticipantId),
      // @ts-expect-error - Ember Data adapter method not typed on MinimumAdapterInterface
      this.store.adapterFor('tas-participant').periodOfEligibility(tasParticipantId),
    ]);

    const templatesFilteredByEligibility = filterEligibleTemplates(
      // @ts-expect-error: not sure
      templates,
      dynamicEligibility,
      programEligibility
    );

    const isDependentProgram = (program: TASProgramTemplateModel) => {
      return program.isDependentProgram;
    };

    const isDependentInstance = (instance: TASProgramInstanceModel) => {
      return instance.isDependentProgram;
    };

    const filteredTemplates = templatesFilteredByEligibility.filter(isDependentProgram);
    // @ts-expect-error: not sure
    const filteredActiveInstances = activeInstances.filter(isDependentInstance);
    // @ts-expect-error: not sure
    const filteredPastInstances = pastInstances.filter(isDependentInstance);

    return {
      templates: filteredTemplates,
      activeInstances: filteredActiveInstances,
      pastInstances: filteredPastInstances,
      employee,
    };
  }
}
